import React from "react";

/**
 * A simple loading spinner component with size options
 */
export function LoadingSpinner({ size = "lg", centered = true }) {
  const sizeClass = {
    sm: "loading-sm",
    md: "loading-md",
    lg: "loading-lg",
    xl: "loading-xl",
  }[size] || "loading-lg";

  return (
    <div className={`${centered ? "flex items-center justify-center p-8" : ""}`}>
      <div className={`loading loading-spinner ${sizeClass}`}></div>
    </div>
  );
} 